mutation UserGroupDelete($input: UserGroupDeleteInput!) {
  userGroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
